<template>
    <v-dialog v-if="generateLinkDialog" :value="generateLinkDialog" max-width="500px" @click:outside="closeDialog">
        <v-card>
            <v-card-title>
                <span class="headline">{{ "Generate link" | t }}</span>
            </v-card-title>

            <v-card-text>
                <v-combobox
                    :label="t('Company name')"
                    :items="shipmentCompanies"
                    :value="companyName"
                    class="mt-0 py-4"
                    clearable
                    dense
                    hide-details
                    @change="updateCompanyName($event)"
                />

                <v-select
                    class="pt-4"
                    v-model="shipmentDirection"
                    :items="directionOptions"
                    :label="'Direction' | t"
                    required
                />
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn text @click="closeDialog">{{ "Cancel" | t }}</v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="generateLink"
                    :disabled="!shipmentDirection || !companyName"
                    :loading="loadingGenerateLinkSubmit"
                >
                    {{ "Create" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    data() {
        return {
            companyName: null,
            shipmentDirection: null,
            directionOptions: [
                {
                    text: this.t("Outgoing"),
                    value: "outgoing",
                },
                {
                    text: this.t("Incoming"),
                    value: "incoming",
                },
            ],
        };
    },
    async mounted() {
        await this.fetchShipmentCompanyOptions();
    },
    computed: {
        ...mapState("ShipmentStore", ["generateLinkDialog", "loadingGenerateLinkSubmit", "shipmentCompanies"]),
    },
    methods: {
        ...mapMutations("ShipmentStore", ["setGenerateLinkDialog","setRequestError", "setRequestSuccess"]),
        ...mapActions("ShipmentStore", ["submitGenerateLink", "fetchShipmentCompanyOptions"]),

        closeDialog() {
            this.setGenerateLinkDialog(false);
            this.companyName = null;
            this.shipmentDirection = null;
        },

        async generateLink() {
            const formData = {
                company_name: this.companyName,
                direction: this.shipmentDirection,
            };

            const url = await this.submitGenerateLink(formData);

            if (url) {
                this.copyToClipboard(url)
                this.closeDialog();
            }
        },
        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.setRequestError(false);
                    this.setRequestSuccess(true);
                    setTimeout(() => this.setRequestSuccess(false), 2500);
                })
                .catch(() => {
                    this.setRequestSuccess(false);
                    this.setRequestError(true);
                    setTimeout(() => this.setRequestError(false), 2500);
                });
        },
        updateCompanyName(e) {
            this.companyName = e;
        },
    },
};
</script>

<style scoped></style>
